"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// This is just to tag graphql fragments for type generation
// original query string which should be passed to fetch function is returned back
const gql = strings => strings.raw[0];
var _default = exports.default = gql;